/** Базовый класс для обработчиков */
class Handler {
    /**
     * Конструктор обьекта.
     * @param {any} node - нода для обработки
     * @param {any} esiComponent - ESI инстанс
     */
    constructor(node, esiComponent) {
        this.onerror = null;
        this.node = null;
        this.esiComponent = null;
        this.node = node;
        this.esiComponent = esiComponent;
    }
    /**
     * Метод обработки ноды
     */
    processNode(document) { }
}
Handler.nodeName = '';

/** Класс обработки ESI:INCLUDE инструкции. */
class HandlerInclude extends Handler {
    /**
     * Конструктор обьекта.
     * @param {T} node - нода для обработки
     * @param {K} esi - ESI инстанс
     */
    constructor(node, esi) {
        super(node, esi);
        this.onerror = null;
    }
    /**
     * Обработка ноды
     * Подгружаем необходимый url, и заменяем текущую ноду на нее
     * @param {Document} document - документ
     */
    processNode(document) {
        const url = this.node.getAttribute('src');
        const onError = this.node.getAttribute('onerror');
        const request = new (this.esiComponent.getLoader())({ url });
        return new Promise((resolve, reject) => {
            request.then((text) => {
                const range = document.createRange();
                const documentFragment = range.createContextualFragment(text);
                this.node.parentNode.replaceChild(documentFragment, this.node);
                resolve(null);
            }, () => {
                this.node.remove();
                resolve(null);
                if (onError && onError !== 'continue') {
                    throw new Error(`Error request!`);
                }
            });
        });
    }
}
/** имя тега за которое отвечает конструктор */
HandlerInclude.nodeName = 'ESI:INCLUDE';

/** Класс обработки ESI:CHOOSE инструкции. */
class HandlerChoose extends Handler {
    /**
     * Конструктор обьекта.
     * @param {T} node - нода для обработки
     * @param {K} esi - ESI инстанс
     */
    constructor(node, esi) {
        super(node, esi);
        this.onerror = null;
    }
    /**
     * Обработка ноды
     * Ищем внутри ноды when инструкции которые отвечают проверке. Если их нет, то ищем otherwise и заменяем на нее
     * @param {Document} document - документ
     */
    processNode(document) {
        const esiWhen = this.node.getElementsByTagName('esi:when');
        const esiOtherwise = this.node.getElementsByTagName('esi:otherwise')[0];
        let rightNode = null;
        for (let elm of esiWhen) {
            if (rightNode) {
                elm.remove();
                continue;
            }
            const testAtr = elm.getAttribute('test');
            if (!testAtr) {
                elm.remove();
                continue;
            }
            const f = new Function('', `return ${testAtr};`);
            const res = f.call(this, '');
            if (res) {
                rightNode = elm;
                continue;
            }
        }
        if (rightNode && esiOtherwise) {
            esiOtherwise.remove();
        }
        if (!rightNode) {
            rightNode = esiOtherwise;
        }
        if (!rightNode) {
            this.node.remove();
            return;
        }
        const fr = document.createDocumentFragment();
        Array.from(rightNode.childNodes).forEach((node) => {
            fr.appendChild(node);
        });
        this.node.parentNode.replaceChild(fr, this.node);
    }
}
/** имя тега за которое отвечает конструктор */
HandlerChoose.nodeName = 'ESI:CHOOSE';

/** Класс реализации обработку мутаций в доме */
class ESIObserver {
    /**
     * Конструктор обьекта.
     * @param {HTMLElement} node - элемент за которым наблюдаем
     */
    constructor(node, esiComponent) {
        this.node = null;
        this.esiComponent = null;
        this.node = node;
        this.esiComponent = esiComponent;
    }
    /**
     * Запускает наблюдателя
     */
    watch() {
        const MutationObserver = window.MutationObserver;
        if (MutationObserver) {
            const obs = new MutationObserver((evt, observer) => {
                this.domUpdateHandler(evt);
            });
            obs.observe(this.node, {
                childList: true,
                subtree: true
            });
        }
        else {
            this.node.addEventListener('DOMNodeInserted', (evt) => {
                this.domUpdateHandler(evt);
            }, false);
        }
    }
    /**
     * Обработчик события мутации Дом
     */
    domUpdateHandler(evt) {
        if (evt instanceof MutationEvent) {
            this.callbackHandler(evt.target);
            return;
        }
        for (let i = 0; i < evt.length; i++) {
            for (let y = 0; y < evt[i].addedNodes.length; y++) {
                const addedNode = evt[i].addedNodes[y];
                this.callbackHandler(addedNode);
            }
        }
    }
    /**
     * Посылает ноду на обработку
     */
    callbackHandler(node) {
        // https://developer.mozilla.org/ru/docs/Web/API/Node/nodeType
        // ELEMENT_NODE type = 1
        if (node.nodeType === 1) {
            this.esiComponent.process(node);
        }
    }
}

const globalFetch = {};
const getGlobal = function () {
    const check = (g) => typeof g !== 'undefined';
    if (check(self))
        return self;
    if (check(window))
        return window;
    if (check(global))
        return global;
    if (check(globalThis))
        return globalThis;
    return undefined;
};
const globObj = getGlobal() || globalFetch;
let loader = globObj.fetch;
/**
 * Cтандартный лоадер контента для обработчиков
 * @param {LoaderDataSchema} params - числовой тип токена
 * @function
 */
const contentLoader = function (params) {
    const p = new Promise((resolve, reject) => {
        if (!params.url || !loader) {
            reject(null);
            return;
        }
        loader(params.url, {
            credentials: 'include',
        }).then((response) => {
            // NOTE: [FEC-837] ESI should be applied only for 200 status response
            if (response && response.status !== 200)
                reject(null);
            response.text().then((text) => {
                resolve(text);
            });
        })
            .catch((e) => {
            reject(null);
        });
    });
    return p;
};

/** Класс реализации хранилища esi компонента */
class Storage {
    /**
     * Конструктор обьекта.
     */
    constructor() {
        this.storage = {};
        this.storage = {};
    }
    /**
     * Добавляет значение в хранилище
     * @param {string} key - числовой тип токена
     * @param {any} value - сохраняемое значение
     */
    set(key, value) {
        this.storage[key] = value;
    }
    /**
     * Получает значение из хранилища
     * @param {string} key - ключ
     * @return {any} - значение из хранилища
     */
    get(key) {
        return this.storage[key] || null;
    }
}

const globalObj = getGlobal();
/** Класс реализации куков в воркере и браузере. */
class Cookies {
    /**
     * Конструктор обьекта.
     */
    constructor() {
        this.data = {};
        this.data = {};
    }
    /**
     * Конструктор обьекта.
     * @return {Promise} - инициализация куков
     */
    init() {
        const p = new Promise((resolve, reject) => {
            if (globalObj && globalObj.cookieStore) {
                const p = globalObj.cookieStore.getAll();
                p.then((cookiesList) => {
                    cookiesList.forEach((cookie) => {
                        this.data[cookie.name] = cookie.value;
                    });
                    resolve(null);
                });
            }
            else {
                this.data = this.fromString();
                resolve(null);
            }
        });
        return p;
    }
    /**
     * Функция изменения состояния автомата.
     * @param {string} name - имя в хранилище
     */
    get(name) {
        return this.data[name];
    }
    /**
     * Парсит куку из строки
     * @return {Accumulator} - обьект хранилища
     */
    fromString() {
        const acc = {};
        const str = ((globalObj && globalObj.cookie) || (globalObj && globalObj.document && globalObj.document.cookie) || '');
        str.split(';').map((data) => data.split('=')).reduce((acc, data) => {
            const name = data[0];
            const value = data[1];
            acc[name] = value;
            return acc;
        }, acc);
        return acc;
    }
}

const environmentIsWorker = typeof importScripts === 'function';
const environmentIsWeb = typeof window === 'object';
// const environmentIsNode = typeof process === 'object' && typeof process.versions === 'object' && typeof process.versions.node === 'string'
/** Класс реализации обработки ESI инструкций. */
class ESI {
    /**
     * Конструктор обьекта.
     * @param {Document} document - документ
     */
    constructor(document = null) {
        var _a;
        this.document = null;
        this.handlers = {};
        this.tagsName = [];
        this.storage = null;
        this.cookies = null;
        this.loader = null;
        this.isStartObserver = false;
        this.loader = contentLoader;
        this.storage = new Storage();
        this.cookies = new Cookies();
        // пробрасываем стандартные переменные в хранилище
        if (environmentIsWorker) {
            this.storage.set('url', self.location.href);
        }
        if (environmentIsWeb && !environmentIsWorker) {
            this.storage.set('url', (_a = document === null || document === void 0 ? void 0 : document.location) === null || _a === void 0 ? void 0 : _a.href);
        }
        this.storage.set('cookies', this.cookies);
        if (document) {
            this.setDocument(document);
        }
    }
    /**
     * Метод запускает обсервер
     */
    startObserver() {
        if (this.isStartObserver) {
            return;
        }
        // если документ является обьектом воркера
        if (this.document.type === 'virtual') {
            return;
        }
        this.isStartObserver = true;
        const obs = new ESIObserver(this.document.body, this);
        obs.watch();
    }
    /**
     * Метод иницилизации и запуска обработки документа
     * @returns {Promise} - промис завершения обработки
     */
    init(options = {}) {
        const { withoutObserver } = options;
        if (!withoutObserver) {
            this.startObserver();
        }
        const p = new Promise((resolve, reject) => {
            this.cookies.init().then(() => {
                this.process(this.document.body).then((document) => {
                    resolve(document);
                });
            });
        });
        return p;
    }
    /**
     * Метод возвращает стандартный лоадер для подгрузок
     */
    getLoader() {
        return this.loader;
    }
    /**
     * Метод добавляет новый обработчик тега
     * @param {typeof Handler} handler - класс обработчика
     */
    addHandler(handler) {
        if (!handler.nodeName)
            throw new Error('Handler don"t have nodeName');
        const nodeName = handler.nodeName.toUpperCase();
        if (this.handlers[nodeName])
            throw new Error(`Handler is allready add for tag ${nodeName}`);
        this.handlers[nodeName] = handler;
        this.tagsName.push(nodeName);
        this.hideEsiTag(nodeName);
    }
    /**
     * Метод удаляет обработчик тега
     * @param {string} nodeName - имя ноды обработчик которой необходимо удалить
     */
    removeHandler(nodeName) {
        nodeName = nodeName.toUpperCase();
        const index = this.tagsName.indexOf(nodeName);
        if (index > -1) {
            this.tagsName.splice(index, 1);
            delete this.handlers[nodeName];
        }
    }
    /**
     * Метод обрабатывает ноду
     * @param {any} node - нода для обработки
     * @returns {Promise} - промис завершения обработки
     */
    process(node) {
        const parentNode = node.parentNode
            ? node.parentNode
            : this.document.body;
        const esiTags = this.findEsiTags(node);
        const rootsEsi = this.findEsiRootNode(esiTags, parentNode);
        let pAll = [];
        rootsEsi.forEach((node) => {
            if (!node.getAttribute('processed')) {
                pAll.push(this.sendNodeToHandler(node));
            }
        });
        if (pAll.length === 0) {
            return Promise.resolve(this.document);
        }
        const p = new Promise((resolve, reject) => {
            Promise.all(pAll).then(() => {
                this.process(parentNode).then(() => {
                    resolve(this.document);
                });
            }, () => {
                this.process(parentNode).then(() => {
                    resolve(this.document);
                });
            });
        });
        return p;
    }
    /**
     * Метод обрабатывает единичную ноду обработчиком
     * @param {any} node - нода для обработки
     */
    sendNodeToHandler(node) {
        node.setAttribute('processed', 'true');
        const { tagName } = node;
        const handler = new (this.handlers[tagName])(node, this);
        const res = handler.processNode(this.document);
        return res || Promise.resolve();
    }
    /**
     * Метод ищет ESI теги в ноде
     * @param {any} node - нода для обработки
     * @returns {Array} - список нод
     */
    findEsiTags(node) {
        const { tagName } = node;
        let tags = [];
        if (this.isSupportNode(tagName)) {
            tags.push(node);
        }
        this.tagsName.forEach((tagName) => {
            tags = tags.concat(Array.from(node.getElementsByTagName(tagName)));
        });
        return tags;
    }
    /**
     * Метод принимает массив ESI нод и выдает ESI ноды рутовые(последнеродительскую если есть)
     * @param {Array} nodes - нода для обработки
     * @returns {Array} - список рутовых нод
     */
    findEsiRootNode(nodes = [], parentNode) {
        const rootNodes = new Set();
        nodes
            .forEach((node) => {
            let lastEsiNode = node;
            while (node.parentNode !== parentNode || !node.parentNode) {
                if (this.isSupportNode(node.tagName)) {
                    lastEsiNode = node;
                }
                node = node.parentNode;
            }
            rootNodes.add(lastEsiNode);
        });
        return rootNodes;
    }
    /**
     * Метод проверяет поддерживается ли тег
     * @param {string} name - имя ноды
     * @returns {boolean} - true если поддерживает
     */
    isSupportNode(name) {
        return this.tagsName.includes(name);
    }
    /**
     * Метод получает хранилище
     * @returns {Storage} - обьект хранилища
     */
    getStorage() {
        return this.storage;
    }
    /**
     * Метод добавляем документ
     * @param {any} document - документ
     */
    setDocument(document = null) {
        if (this.document)
            throw new Error('Document is already added.');
        this.document = document;
        this.addHandler(HandlerInclude);
        this.addHandler(HandlerChoose);
    }
    // скрывает ESI теги с их содержимом
    /**
     * Метод скрывает ESI теги с их содержимом
     * @param {string} name - документ
     */
    hideEsiTag(name) {
        if (this.document.type === 'virtual') {
            return;
        }
        name = name.toLocaleLowerCase().replace(':', '\\:');
        const rules = 'display: none;';
        const style = this.document.createElement('style');
        style.type = 'text/css';
        this.document.getElementsByTagName('head')[0].appendChild(style);
        style.appendChild(document.createTextNode(`${name} {  ${rules} }`));
    }
}
/** запускает воркер */
ESI.startWorker = function (isStream = false, dirPath = '.', libName = '') {
    let scriptName;
    if (!isStream && libName) {
        scriptName = `${dirPath}/${libName}`;
    }
    else {
        scriptName = isStream
            ? `${dirPath}/esi-stream-sw.js`
            : `${dirPath}/esi-sw.js`;
    }
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register(scriptName)
            .then(() => navigator.serviceWorker.ready.then((worker) => {
            console.log('SW Start:', worker);
            // worker.sync.register('syncdata')
        }))
            .catch((err) => console.log(err));
        navigator.serviceWorker.onmessage = (e) => {
            console.log(e);
        };
    }
};

export { ESI };
//# sourceMappingURL=index.js.map
